import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 40px 0;
  overflow: hidden;
`;

export const Container = styled.div`
  width: 100%;
  height: 70vh;
  max-width: 1440px;
  padding: 0 40px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 1366px) {
    height: 68vh;
  }
`;

export const Content = styled.main`
  width: 100%;
  max-width: 776px;
  height: 100%;

  display: flex;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 1366px) {
    max-width: 700px;
    justify-content: flex-start;
  }

  @media (max-width: 768px) {
    justify-content: center;
  }

  h1 {
    font-size: 65px;
    line-height: 150%;

    @media (max-width: 1366px) {
      font-size: 55px;
      margin-top: 20px;
    }

    @media (max-width: 414px) {
      font-size: 35px;
      margin-top: 0;

      span {
        display: block;
      }
    }
  }

  p {
    font-size: 22px;
    line-height: 130%;
    margin-top: 20px;

    @media (max-width: 414px) {
      font-size: 16px;
    }
  }

  a {
    margin-top: 50px;

    @media (max-width: 1366px) {
      margin-top: 30px;
    }
  }
`;
